export const rarKeys = {
  all: ["rarData"] as const,
  rar: (riskId: string | null, sysElId: string, variantId: string | null) =>
    [...rarKeys.all, riskId, sysElId, variantId] as const,
};
